import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { getUserDetails } from "../../utils/verifyUser";

import { getMediaGallery, uploadMedia, mediaRename, deleteMedia, assetsMap } from "./actions";
import { setSideMenu } from "../Sidemenu/actions";
import Loader from "../sharedComponents/Loader";
import MediaCard from "../sharedComponents/MediaCard";
import MediaDropZone from "../sharedComponents/DropZone";
import SharedModal from "../sharedComponents/Modal";
import NoData from "../sharedComponents/NoData";
import Header from "../header";
import upload from "../../assets/images/modal-icon.png";
import { useTranslation } from "react-i18next";

const VideoGallery = ({
	getMediaGallery,
	menu,
	history,
	setSideMenu,
	uploadMedia,
	deleteMedia,
	mediaRename,
	gallery,
	responseCount,
	assetsMap,
}) => {
	const [videoList, setVideoList] = useState(gallery && gallery.length > 0 ? gallery : []);
	const [show, setShow] = useState(null);
	const [videoUploadList, setVideoUploadList] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [isVideoGallery] = useState(true);
	const [isEditing, setIsEditing] = useState(false);
	const [deleteItem, setDeleteItem] = useState(null);
	const [videoUrl, setVideoUrl] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [index, setIndex] = useState(1);
	const [loader, setLoader] = useState(false);
	const [selectAll, setSelectAll] = useState(false);
	const [deleteAll, setDeleteAll] = useState(false);
	const [deleteItemList, setDeleteItemList] = useState([]);
	const [fileTimeOut, setFileTimeOut] = useState(null);
	const [searchTimeout, setSearchTimeout] = useState(null);
	const {t} = useTranslation();

	const selectAllRef = useRef(null);

	const userRole = getUserDetails() && getUserDetails().role && getUserDetails().role.description;

	useEffect(() => {
		const location = history.location.pathname.split("/");
		setSideMenu({
			menu: [{ title: location[2] }],
			language: "",
		});
	}, [history, setSideMenu]);

	useEffect(() => {
		searchTerm &&
			getMediaGallery(`video&SortBy=LastModified&SortDirection=Desc&FileName=${searchTerm}`).then((res) => {
				if (res.response.records.length > 0) {
					setVideoList(res.response.records);
				} else {
					setVideoList([]);
				}
			});
	}, [searchTerm, getMediaGallery]);

	useEffect(() => {
		setLoader(true);
		getMediaGallery("video&SortBy=LastModified&SortDirection=Desc").then((res) => {
			if (res && res.response && res.response.records) {
				setLoader(false);
				setVideoList([...res.response.records]);
			}
		});
	}, [getMediaGallery, setVideoList, setLoader]);

	const renderUpdatedList = () =>
		getMediaGallery(`video&SortBy=LastModified&SortDirection=Desc&Index=${index}`).then((res) => {
			if (res.response.hasNext === true) {
				setLoader(false);
				setIsLoading(false);
				setIndex(index + 1);
				res && res.response && res.response.records && setVideoList([...videoList, ...res.response.records]);
			} else {
				setLoader(false);
				setIndex(1);
			}
		});

	const [uploadFailedList, setUploadFailedList] = useState([]);
	let failedEntry = [];

	const uploadFile = (i) => {
		if (i < videoUploadList.length) {
			const formData = new FormData();
			formData.append("uploadedFile", videoUploadList[i]);
			uploadMedia(formData).then((res) => {
				if (res.statusCode === 200) {
					uploadFile(i + 1);
				} else if (res.statusCode === 709) {
					failedEntry.push(videoUploadList[i]);
					setUploadFailedList(failedEntry);
					uploadFile(i + 1);
				} else {
					setLoader(false);
					NotificationManager.error(
						res.statusCode === 704 ? t("helpers.gallery.filelimit") : t("helpers.utils.notification.error"),
						"",
						3000
					);
				}
			});
		} else if (i >= videoUploadList.length) {
			failedEntry && failedEntry.length > 0 && setShow("uploadFailed");
			assetsMap();
			getMediaGallery("video&SortBy=LastModified&SortDirection=Desc").then((res) => {
				if (res && res.response && res.response.records) {
					setLoader(false);
					setVideoList([...res.response.records]);
					failedEntry.length === 0 && NotificationManager.success(t("helpers.utils.uploadsuccesful"), "", 3000);
				}
			});
		}
	};

	const handleUpload = (e) => {
		setLoader(true);
		uploadFile(0);
		setShow(null);
		setVideoUploadList([]);
	};

	const multipleDelete = () => {
		setLoader(true);
		setShow(null);
		if (deleteItemList && deleteItemList.length > 0) {
			const deleteFileKey = deleteItemList.map((item) => item.fileKey);
			deleteMedia(deleteAll ? { deleteAll: true } : { fileKeys: deleteFileKey }).then((res) => {
				if (res) {
					if (res.statusCode === 200) {
						assetsMap().then((response) => {
							if (deleteAll) {
								NotificationManager.success(t("helpers.audio.deletedsuccess"), "", 3000);
								setLoader(false);
								setVideoList([]);
							} else {
								getMediaGallery("Video&SortBy=LastModified&SortDirection=Desc").then((res) => {
									if (res && res.response && res.response.records) {
										setVideoList([...res.response.records]);
										setLoader(false);
										NotificationManager.success(t("helpers.audio.deletedsuccess"), "", 3000);
									}
								});
							}
						});
					} else {
						NotificationManager.error(res.response.message, "", 2000);
						setLoader(false);
					}
					setDeleteItemList([]);
				}
			});
		}
	};

	const deleteVideo = () => {
		setLoader(true);
		const deleteFileKey = videoList.filter((item) => (item.filePath === deleteItem ? item : null));
		deleteFileKey[0] &&
			deleteFileKey[0].fileKey &&
			deleteMedia({ fileKeys: [deleteFileKey[0].fileKey] }).then((res) => {
				if (res) {
					if (res.statusCode === 200) {
						assetsMap().then((response) => {
							getMediaGallery("video&SortBy=LastModified&SortDirection=Desc").then((res) => {
								if (res && res.response && res.response.records) {
									setVideoList([...res.response.records]);
									setLoader(false);
									NotificationManager.success(t("helpers.audio.deletedsuccess"), "", 3000);
								}
							});
						});
					} else {
						NotificationManager.error(res.response.message, "", 2000);
						setLoader(false);
					}
					setShow(null);
					setDeleteItem("");
				}
			});
	};

	const handleSelectAll = () => {
		if (selectAllRef.current.checked === true) {
			setSelectAll(true);
			setDeleteItemList([...videoList]);
		} else {
			setSelectAll(false);
			setDeleteItemList([]);
		}
	};
	const handleClearSelection = () => {
		setDeleteAll(false);
		setSelectAll(false);
		setDeleteItemList([]);
		selectAllRef.current.checked = false;
	};

	const handleVideoPlayer = (value) => {
		setShow("VideoModal");
		setVideoUrl(value);
	};

	const handleClose = () => setShow(null);

	const handleUploadClose = () => {
		setShow(null);
		setUploadFailedList([]);
		failedEntry = [];
	};

	const handleChange = (e) => {
		const value = e.target.value;
		setLoader(true);
		clearTimeout(searchTimeout);
		const timeOut = setTimeout(() => {
			if (value && value.length > 0) {
				setSearchTerm(value);
				setLoader(false);
			} else {
				setSearchTerm("");
				getMediaGallery("video&SortBy=LastModified&SortDirection=Desc").then((res) => {
					if (res && res.response && res.response.records) {
						setLoader(false);
						setVideoList([...res.response.records]);
					}
				});
			}
		}, 500);
		setSearchTimeout(timeOut);
	};

	const handleDelete = (item) => {
		setDeleteItem(item);
		setShow("ConfirmationModal");
	};

	const handleImageRename = (oldName, newName, id) => {
		setLoader(true);
		mediaRename({
			oldFileName: oldName,
			newFileName: "xmlassets/video/" + newName,
		}).then((res) => {
			if (res.statusCode === 200) {
				setIsEditing(false);
				setLoader(false);
				setVideoList(
					videoList.map((item) =>
						item.filePath === id
							? {
									...item,
									fileName: newName,
									fileKey: "xmlassets/video/" + newName,
									filePath: "https://biblingo.s3.amazonaws.com/xmlassets/video/" + newName,
							  }
							: item
					)
				);
				NotificationManager.success(t("helpers.gallery.renamesuccess"), "", 3000);
			} else {
				NotificationManager.error(res.response.message, "", 2000);
				setLoader(false);
			}
			setIsEditing(false);
		});
	};

	const uploadModalHead = () => <span>{t("helpers.utils.uploadvideos")}</span>;

	const uploadModalBody = () => (
		<div className="px-3">
			<div className="upload-container rounded">
				<MediaDropZone
					uploadFormat=".mp4"
					fileSize={524288000}
					inputWithFilesContent={"+"}
					submitButtonContent={null}
					isVideoGallery={isVideoGallery}
					maxFiles={10}
					fileTimeOut={fileTimeOut}
					setFileTimeOut={setFileTimeOut}
					uploadedFileList={videoUploadList}
					setLoader={setLoader}
					setUploadedFileList={setVideoUploadList}
					dropzoneClass="videoUpload"
				/>
			</div>
		</div>
	);

	const uploadModalFooter = () => (
		<div>
			<button className="btn-cancel" onClick={() => setShow(null)}>
				{t("helpers.utils.cancel")}
			</button>
			<button
				className="btn-upload"
				onClick={handleUpload}
				disabled={videoUploadList && videoUploadList.length > 0 ? false : true}>
				{t("helpers.utils.upload")}
			</button>
		</div>
	);

	const confirmationModalBody = () => (
		<React.Fragment>
			{t("helpers.utils.deleteprompt")}
			<b>
				{deleteItemList && deleteItemList.length > 0
					? deleteAll
						? ` ${responseCount} files?`
						: deleteItemList.length > 1
						? ` ${deleteItemList.length} files?`
						: ` ${deleteItemList.length} file?`
					: ` ${deleteItem && deleteItem.split("/").pop()}? `}
			</b>
		</React.Fragment>
	);

	const confirmationModalFooter = () => (
		<React.Fragment>
			<button className="btn-cancel" onClick={() => setShow(null)}>
				{t("helpers.utils.no")}
			</button>
			<button
				className="btn-upload"
				onClick={() => (deleteItemList && deleteItemList.length > 0 ? multipleDelete() : deleteVideo())}>
				{t("helpers.utils.yes")}
			</button>
		</React.Fragment>
	);
	const uploadFailedModal = () => {
		return (
			<React.Fragment>
				<div className="upload-failed d-flex justify-content-center ">
					<img src={upload} alt="upload" />
				</div>
				<h3 className="upload-modal-text mb-2 text-center">{t("helpers.gallery.fileexists")}</h3>
				<ul className="list-unstyled text-center">
					{uploadFailedList &&
						uploadFailedList.length > 0 &&
						uploadFailedList.map((item, index) => <li key={index}>{item.name}</li>)}
				</ul>
			</React.Fragment>
		);
	};

	const videoModalBody = () => (
		<div>
			<video controls controlsList="nofullscreen nodownload" src={videoUrl}></video>
		</div>
	);

	return (
		<div
			className="empty"
			onScroll={(e) => {
				if (e && e.nativeEvent && e.nativeEvent.target) {
					const scrollHeight = e.nativeEvent.target.scrollHeight;
					const offsetHeight = e.nativeEvent.target.offsetHeight;
					const scrollTop = e.nativeEvent.target.scrollTop;

					if (scrollHeight - offsetHeight - 50 < scrollTop) {
						if (!isLoading && show === null) {
							renderUpdatedList();
							setLoader(true);
							setIsLoading(true);
						}
					}
				}
			}}>
			<Header menu={menu} head={"Videos"} history={history} />
			<div className="d-flex justify-content-between px-4 sub-header-wrapper">
				{loader && <Loader />}
				<div className="position-relative search-container">
					<i className="icon icon-search" />
					<input
						className="media-search"
						type="text"
						placeholder={t("languagelearning.fluencydrills.searchhere")}
						onChange={(e) => handleChange(e)}
					/>
				</div>

				<div className="d-flex align-items-center">
					{deleteItemList && deleteItemList.length > 0 && (
						<div className="position-relative d-flex align-items-center">
							<label className="custom-checkbox mr-2">
								<span className="pl-4">{t("helpers.utils.selectall")}</span>
								<input type="checkbox" ref={selectAllRef} onChange={() => handleSelectAll()} />
								<span className="tickmark"></span>
							</label>

							<button className="mr-2 delete-icon" onClick={() => setShow("ConfirmationModal")}>
								<i className="icon icon-delete1"></i>
							</button>
						</div>
					)}
					{userRole === "Administrator" && (
						<Button className="upload-btn" onClick={() => setShow("uploadModal")}>
							<i className="icon icon-upload mr-2" />
							{t("helpers.utils.upload")}
						</Button>
					)}
				</div>
			</div>
			{selectAll && (
				<div className="px-4 mt-4">
					<div className="delete-all-container text-center">
						{deleteAll ? (
							<div>
								{responseCount} videos were selected .
								<b className="select-all-phrase pl-2" onClick={() => handleClearSelection()}>
									{t("helpers.utils.clearselection")}
								</b>
							</div>
						) : (
							<div>
								{videoList && videoList.length} {t("helpers.gallery.videoselected")}
								<b className="select-all-phrase pl-2" onClick={() => setDeleteAll(true)}>
									{t("helpers.gallery.selectallvideo")}
								</b>
							</div>
						)}
					</div>
				</div>
			)}
			<div className="px-4 mt-4">
				{videoList && videoList.length > 0 ? (
					<div className="row media-gallery">
						{videoList.map((item) => (
							<div className="col-lg-3 col-md-4 col-sm-2" key={item.filePath}>
								{item.filePath && (
									<MediaCard
										cardData={item}
										isEditing={isEditing}
										isVideoGallery={isVideoGallery}
										handleImageRename={handleImageRename}
										setIsEditing={setIsEditing}
										setDeleteItem={handleDelete}
										handleVideoPlayer={handleVideoPlayer}
										setDeleteItemList={setDeleteItemList}
										deleteItemList={deleteItemList}
										selectAll={selectAll}
									/>
								)}
							</div>
						))}
					</div>
				) : (
					<NoData />
				)}
			</div>
			<SharedModal
				show={show === "uploadModal" ? true : false}
				handleClose={handleClose}
				modalHead={uploadModalHead()}
				modalBody={uploadModalBody()}
				modalFooter={uploadModalFooter()}
				centered="true"
				modalClass="gallery"
			/>
			<SharedModal
				show={show === "ConfirmationModal" ? true : false}
				handleClose={handleClose}
				modalBody={confirmationModalBody()}
				modalFooter={confirmationModalFooter()}
				modalClass="confirm-modal"
			/>
			<SharedModal
				show={show === "VideoModal" ? true : false}
				handleClose={handleClose}
				modalBody={videoModalBody()}
				modalClass="video-wrapper"
			/>
			<SharedModal
				show={show === "uploadFailed" ? true : false}
				handleClose={handleUploadClose}
				modalBody={uploadFailedModal()}
				modalClass=""
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	menu: state.sideMenu.menu,
	language: state.sideMenu.language,
	gallery: state.mediaGallery.gallery,
	responseCount: state.mediaGallery.count,
});

const mapDispatchToProps = {
	getMediaGallery,
	setSideMenu,
	uploadMedia,
	mediaRename,
	deleteMedia,
	assetsMap,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoGallery));
